<template>
    <CModal title="Mensagem privada" color="primary" :show.sync="value">
        <!-- Add new alert -->
        <CRow class="mt-3">
            <CCol sm="12">
            <CTextarea placeholder="Novo alerta" vertical v-model="newAlert" rows="3"/>
            </CCol>
        </CRow>
        <!-- Footer buttons -->
        <footer slot="footer">
            <button type="button" class="mr-1 btn btn-secondary" @click="cancelTapped"> Cancelar </button>
            <button type="button" class="ml-1 btn btn-primary" @click="okTapped"> Confirmar </button>
        </footer>
    </CModal>
</template>

<script>
export default {
    data()
    {
        return {
            newAlert: '',
        }
    },
    props:{    
        value:
        {
            type: Boolean,
            default: false
        },
        personName:
        {
            type: String,
            default: ''
        },
    },
    methods:
    {
        cancelTapped: function()
        {
            this.$emit('cancel-tapped');
            this.$emit('input', false);
        },
        okTapped: function()
        {
            if(this.newAlert)
            {
                this.$emit('ok-tapped', this.newAlert);
                this.$emit('input', false);
            }
        }
    },
    watch:
    {
        value: function(val)
        {
            this.$emit('input', this.value);
        }
    }
}
</script>

<style>

</style>